<template>
    <div>
        <pre-loader v-if="isLoading"></pre-loader>
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('teachers')"/></template>
            <template v-slot:center>
                <div class="sas-head-center">
                    <v-text-field outlined dense v-model="search['query']" @keyup.enter="searchTeacherByFIO"
                                  @input="search.query !== '' ? showIcon = true : showIcon = false"
                                  prepend-inner-icon="mdi-magnify"
                                  :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>
                    <v-btn color="primary" class="text-no-wrap"
                           @click="searchTeacherByFIO" v-text="$t('search')"/>
                </div>
            </template>
            <template v-slot:right>
                <ExcelJs :rows="exportRows" :file-name="exportName" :headers="exportHeaders"></ExcelJs>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="instructors" :total-elements="totalElements" :totalPages="totalPages"
                        :page-size="pageSize" :current-page="currentPage" @leftClick="onLeftClick"
                        @rightClick="onRightClick">
                <template v-slot:firstItem>
                    <v-select :items="filterSchoolCourses" item-text="courseTitle" item-value="courseCode" outlined
                              :label="$t('subjectFilter')" class="select-course" @change="filterByCourse" dense/>
                </template>
                <template v-slot:head>
                    <th>№</th>
                    <th v-html="$t('full_name')"/>
                    <th v-html="$t('course')"/>
                    <th v-html="$t('phone')"/>
                </template>
                <template v-slot:body="{ item }">
                    <td v-html="(currentPage - 1) * 10 + item['index'] + 1"/>
                    <td v-html="item['lastName'] + ' ' + item['firstName'] + ' ' + checkMiddleName(item['middleName'])"/>
                    <td v-html="translateCourses(item['courses'])" class="instr-courses"/>
                    <td v-html="item['phone']"/>
                </template>
            </SmartTable>
        </div>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { InstructorCourseService } from '@/_services/instructor-course.service'
import { PersonService } from '@/_services/person.service'
import ExcelJs from '@/components/excel-export/ExcelJs'
import { FileImportService } from '@/_services/file-import.service'
import InstructorService from '@/_services/instructor.service'
import PreLoader from '@/components/preloader/PreLoader'
import { CourseService } from '@/_services/course.service'
const fileImportService = new FileImportService()
const personService = new PersonService()
const instructorCourseService = new InstructorCourseService()
const courseService = new CourseService()

export default {
    name: 'Teachers',
    components: {PreLoader, ExcelJs, SuperAdminSchoolHead, SmartTable},
    data: () => ({
        langObj: {ru: 'courseTitle', kg: 'courseTitleKG', en: 'courseCode'},
        required: [v => !!v || this.$t('required')],
        isAddUser: false,
        instructors: [],
        user: { pin: '' },
        isEdit: false,
        exportName: '',
        exportRows: [],
        exportHeaders: [],
        isAddFile: false,
        totalElements: 0,
        pageSize: 0,
        currentPage: 1,
        isLoading: false,
        schoolCourses: [],
        allSchoolCourses: [],
        filterSchoolCourses: [],
        teacherCourses: [],
        totalPages: 1,
        addTeacherCourse: {archived: false, courseId: 0, personId: 0, schoolId: 0},
        selectedCourseCode: '',
        showIcon: false,
        deleteTeacherId: '',
        search: {query: ''}
    }),
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        },
        school () {
            return this.userProfile.schools[0]
        },
        currentLang () {
            return this.$root.$i18n.locale
        }
    },
    async mounted () {
        this.addTeacherCourse.schoolId = this.userProfile.schools[0].id
        this.fetchInstructors(0)
        this.fetchSchoolCourses()
    },
    methods: {
        fetchInstructors (page, size = 10) {
            this.isLoading = true
            this.instructors = []
            InstructorService.list(
                page,
                this.school.id,
                this.selectedCourseCode,
                size,
                this.search.query
            )
                .then((res) => {
                    this.totalPages = res.page.totalPages
                    this.totalElements = res.page.totalElements
                    this.pageSize = res.page.size
                    this.currentPage = res.page.number + 1
                    if (res['_embedded']) {
                        this.instructors = res['_embedded']['instructorResourceList']
                            .map((teacher, i) => ({ ...teacher, index: i }))
                    }
                    this.exportHeaders = [
                        this.$t('full_name'),
                        'Предмет',
                        'Логин/Пароль',
                        this.$t('birthDate'),
                        'Телефон',
                        'Пол'
                    ]
                    this.exportRows = this.instructors.map((i) => {
                        return [
                            i.lastName + ' ' + i.firstName + ' ' + this.checkMiddleName(i.middleName),
                            this.translateCourses(i.courses),
                            i.username,
                            i['birthDay'],
                            i.phone,
                            i.gender = i.gender === 'MALE' ? 'M' : 'Ж'
                        ]
                    })
                    this.exportName = 'Умная школа: Учителя'
                    this.isLoading = false
                })
                .catch(err => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        filterByCourse (courseCode) {
            this.search.query = ''
            this.currentPage = 1
            if (courseCode) {
                this.selectedCourseCode = courseCode
                this.fetchInstructors(0)
            } else {
                this.selectedCourseCode = ''
                this.fetchInstructors(0, 1000)
            }
        },
        translateCourses (courses) {
            const translatedArr = []
            courses.forEach((course) => {
                translatedArr.push(course[this.langObj[this.currentLang]])
            })
            return translatedArr.join(', ')
        },
        checkMiddleName (middleName) {
            return middleName || ''
        },
        fetchSchoolCourses () {
            courseService.listBySchool(this.userProfile.schools[0].id, '', 0, 0).then((res) => {
                courseService.listBySchool(this.userProfile.schools[0].id, '', 0, res.totalElements)
                    .then((res) => {
                        this.schoolCourses = res.content
                        this.allSchoolCourses = res.content
                        this.filterSchoolCourses = JSON.parse(
                            JSON.stringify(res.content.sort((a, b) => a.courseTitle.localeCompare(b.courseTitle)))
                        )
                        this.filterSchoolCourses.unshift({ courseTitle: 'Показать все', courseCode: '' })
                    })
            })
        },
        getLocaleCourseTitle (courseObj) {
            return courseObj[this.langObj[this.currentLang]]
        },
        clearSearch () {
            this.showIcon = false
            this.search.query = ''
            this.searchTeacherByFIO()
        },
        searchTeacherByFIO () {
            this.currentPage = 1
            this.selectedCourseCode = ''
            this.fetchInstructors(0)
        },
        onAddAdmin () {
            this.isAddUser = true
            this.isEdit = false
            this.user = {}
        },
        onCloseModal () {
            this.isAddUser = false
            if (this.isEdit) {
                personService.getById(this.user.id).then((res) => {
                    this.instructors = this.instructors.map((instructor) => {
                        if (instructor.id === res.id) {
                            for (const key in res) {
                                if (res.hasOwnProperty(key) && instructor.hasOwnProperty(key)) {
                                    instructor[key] = res[key]
                                }
                            }
                        }
                        return instructor
                    })
                })
            } else this.fetchInstructors(0)
        },
        downloadTemplate () {
            const a = document.createElement('a')
            a.download = 'Шаблон импорта учителя.xlsx'
            a.href = '/docs/Шаблон_Мугалим.xlsx'
            a.click()
        },
        editUser (item) {
            personService.getById(item.id).then(res => {
                this.user = {
                    id: res.id,
                    name: res.firstName,
                    surname: res.lastName,
                    middleName: res.middleName,
                    gender: res.gender,
                    phone: res.phone,
                    courseId: item.courseId,
                    dob: res.dateOfBirth,
                    userId: res.userId,
                    username: item.username
                }
                this.isAddUser = true
                this.isEdit = true
            }).catch(err => console.log(err))
        },
        // onSubmit (data) {
        //     if (this.$refs.importFile.$refs.importForm.validate()) {
        //         this.isLoading = true
        //         const d = {
        //             languageId: data.languageId,
        //             chronicleId: data.chronicleId,
        //             file: data.file,
        //             schoolId: this.userProfile.schools[0].id
        //         }
        //         if (data['isIsouMode']) {
        //             fileImportService.importIsouInstructor(d).then(res => {
        //                 this.$toast.success(this.$t('success'))
        //                 this.isAddFile = false
        //                 this.fetchInstructors(0)
        //                 this.isLoading = false
        //             }).catch(err => {
        //                 this.isLoading = false
        //                 console.log(err)
        //             })
        //         } else {
        //             fileImportService.importInstructor(d).then(res => {
        //                 this.$toast.success(this.$t('success'))
        //                 this.isAddFile = false
        //                 this.fetchInstructors(0)
        //                 this.isLoading = false
        //             }).catch(err => {
        //                 this.isLoading = false
        //                 console.log(err)
        //             })
        //         }
        //     }
        // },
        onLeftClick () {
            this.currentPage--
            this.fetchInstructors(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchInstructors(this.currentPage - 1)
        },
        // addCourseModal (instructor) {
        //     this.isLoading = true
        //     this.addTeacherCourse.courseId = ''
        //     this.addTeacherCourse.personId = instructor.id
        //     this.schoolCourses = this.allSchoolCourses
        //     instructorCourseService.listByInstructor(instructor.id).then((res) => {
        //         this.teacherCourses = res['_embedded'] ? res['_embedded']['instructorCourseResourceList'] : []
        //         if (this.teacherCourses.length) {
        //             this.teacherCourses = this.teacherCourses.map((course) => {
        //                 course.courseCode = course.courseName
        //                 return course
        //             })
        //             const existCourses = this.teacherCourses.map(course => course.courseId)
        //             existCourses.forEach((existCourseId) => {
        //                 this.schoolCourses = this.schoolCourses.filter(course => course.id !== existCourseId)
        //             })
        //         }
        //         this.isLoading = false
        //         this.$modal.show('add-course-modal')
        //     }).catch((err) => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // },
        // submitAddTeacherCourse () {
        //     if (this.$refs.addCourseForm.validate()) {
        //         this.isLoading = true
        //         instructorCourseService.create(this.addTeacherCourse).then(() => {
        //             this.fetchInstructors()
        //             this.isLoading = false
        //             this.$toast.success('Успешно добавлено!')
        //             this.$modal.hide('add-course-modal')
        //         }).catch((err) => {
        //             this.$toast.error(err)
        //             this.isLoading = false
        //         })
        //     }
        // },
        // deleteTeacher (teacher, confirm) {
        //     if (confirm) {
        //         this.deleteTeacherId = teacher.id
        //         this.$modal.show('delete-teacher-modal')
        //     } else {
        //         this.isLoading = true
        //         InstructorService.deleteInstructor(this.deleteTeacherId).then(() => {
        //             this.$modal.hide('delete-teacher-modal')
        //             this.$toast.success(this.$t('successDeleted'))
        //             this.filterByCourse(this.selectedCourseCode)
        //         }).catch((err) => {
        //             this.$toast.error(err)
        //             this.isLoading = false
        //         })
        //     }
        // },
        // deleteTeacherCourse (instrCourseId, index) {
        //     this.isLoading = true
        //     instructorCourseService._delete(instrCourseId).then(() => {
        //         this.isLoading = false
        //         this.teacherCourses.splice(index, 1)
        //         this.$toast.success(this.$t('successDeleted'))
        //         this.fetchInstructors(0)
        //     }).catch((err) => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // }
    }
}
</script>
